import { motion } from "framer-motion";
import Button from '../../components/Button';
import './steps.scss';
import { VERSION } from "../../config/config";
import { Loader } from "../../components/Loader";
import { useToast } from "../../hooks/toast";
import { useState } from "react";
import sendInscriptionData from "../../services/fetch";

export default function Step3(props) {
    const { token, step, setStep, step1Data, yearSelected, carrerSelected, placeSelected, modeSelected, sectorSelected, x, setX, setInvoiceData, loading, setLoading, generateFullPayment } = props;
    const { notify: message } = useToast();
    const [loaderMessage, setLoaderMessage] = useState("Procesando inscripción, por favor espere...");

    const doFullInscription = async () => {
        setLoading(true);
        setLoaderMessage("Iniciando inscripción y generando solicitud, esto puede demorar hasta 1 minuto...");
        try {
            const data = {
                apellido: step1Data.surname,
                nombre: step1Data.name,
                tdocu: step1Data.document_type,
                ndocu: step1Data.document_number,
                codTelefono: step1Data.whatsapp_prefix,
                telefono: step1Data.whatsapp_number,
                email: step1Data.email,
                tipoEstudio: "Grado",
                anio: Number(yearSelected.value),
                carrera: Number(carrerSelected.value),
                lugar: Number(placeSelected.value),
                modo: Number(modeSelected.value),
                sector: Number(sectorSelected.value)
            };
            const response = await sendInscriptionData(data, token, (text) => {
                if (typeof text === 'string') {
                    setLoaderMessage(text);
                }
            }, generateFullPayment);

            const traditionalInvoiceStep = Array.isArray(response.pasos)
                ? response.pasos.find(p => !!p.nrocomp1)
                : null;
            const nroComp1 = traditionalInvoiceStep?.nrocomp1 ?? null;
            const nroComp2 = traditionalInvoiceStep?.nrocomp2 ?? null;
            if (!nroComp1 || !nroComp2) {
                throw new Error("fallo la consult");
            }
            if (response?.total1) {
                // setPrice(response.total1.toLocaleString('es-ar', {
                //     style: 'currency',
                //     currency: 'ARS',
                //     minimumFractionDigits: 2
                // }));
            }

            setInvoiceData({ ...response, nrocomp1: nroComp1, nrocomp2: nroComp2 });

            message({ success: true });
            setStep(step + 1);
            setX(1000);
        } catch (error) {
            message({
                success: false,
                error: { errors: ['Error al procesar la inscripción'] }
            });
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizarClick = async () => {
        if (loading) return;
        await doFullInscription();
    };

    return (
        <motion.div
            initial={{ x: x }}
            transition={{ duration: 0.5 }}
            animate={{ x: 0 }}
        >
            <div className='box box-flex'>

                <div className="box-header">
                    <span className="step-numer">{step + 1}</span>
                    <h2>Confirmación y forma de pago</h2>
                </div>
                <div className="box-body">
                    <div className="show-data">
                        <div className="title-content">
                            <span className="title">Arancel de inscripcion: <span className="info">{carrerSelected.label}</span></span>
                        </div>
                        <hr />
                        <div className="info-content">
                            <p className='my-1'>
                                <span className="label">Nombre y apellido:</span>
                                <span className="info">{step1Data.name} {step1Data.surname}</span>
                            </p>
                            <p className='my-1'>
                                <span className="label">{step1Data.document_type}:</span>
                                <span className="info">{step1Data.document_number}</span>
                            </p>
                            <hr />
                            <p className='my-1'>
                                <span className="label">En la sede:</span>
                                <span className="info">{placeSelected.label}</span>
                            </p>
                            <p className='my-1'>
                                <span className="label">Modalidad:</span>
                                <span className="info">{modeSelected.label}</span>
                            </p>
                            <p className='my-1'>
                                <span className="label">Año:</span>
                                <span className="info">{yearSelected.label}</span>
                            </p>
                        </div>
                        <hr />
                    </div>
                </div>
                {!loading &&
                    <>
                        <div className='box-footer btn-group'>
                            <Button type="button" className='btn-step btn-goback' onClick={() => { setStep(step - 1); setX(-1000); }}>Volver</Button>
                            <Button type="button" className='btn-step' onClick={handleFinalizarClick}>Continuar</Button>
                        </div>
                    </>
                }
                {loading &&
                    <Loader message={loaderMessage} />
                }
                <span className='version'>{VERSION}</span>
            </div>
        </motion.div>
    );
}